module.exports = __webpack_public_path__ + "img/kobp.1485dcbf.jpg";